import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { MilestoneTemplateCreateDTO, MilestoneTemplatePagedResultVO, MilestoneTemplateUpdateDTO, MilestoneTemplateVO, TemplateOwnersUpdateDTO } from '../types';

export const templateApi = {
  /** 分页列表；includeDetail 仅里程碑配置页使用，列表项会附带 milestones */
  getList: async (params?: {
    name?: string;
    pageNum?: number;
    pageSize?: number;
    includeDetail?: boolean;
  }): Promise<MilestoneTemplatePagedResultVO> => {
    const query = new URLSearchParams();
    if (params?.name) query.set('Name', params.name);
    query.set('PageNum', String(params?.pageNum ?? 1));
    query.set('PageSize', String(params?.pageSize ?? 9999));
    if (params?.includeDetail) query.set('IncludeDetail', 'true');
    const response = await fetch(`${API_ENDPOINTS.TEMPLATES.LIST}?${query}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<MilestoneTemplatePagedResultVO>(response);
  },

  getById: async (id: number): Promise<MilestoneTemplateVO> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.DETAIL(id), {
      headers: getAuthHeaders(),
    });
    return handleResponse<MilestoneTemplateVO>(response);
  },

  /** 详情（含 milestones 列表） */
  getDetail: async (id: number): Promise<MilestoneTemplateVO> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.DETAIL_FULL(id), {
      headers: getAuthHeaders(),
    });
    return handleResponse<MilestoneTemplateVO>(response);
  },

  /** 创建，返回以后端为准（完整 VM） */
  create: async (data: MilestoneTemplateCreateDTO): Promise<MilestoneTemplateVO> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.CREATE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<MilestoneTemplateVO>(response);
  },

  update: async (id: number, data: MilestoneTemplateUpdateDTO): Promise<void> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.UPDATE(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    await handleResponse<unknown>(response);
  },

  delete: async (id: number): Promise<void> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.DELETE(id), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    await handleResponse<unknown>(response);
  },

  updateOwners: async (id: number, data: TemplateOwnersUpdateDTO): Promise<void> => {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.UPDATE_OWNERS(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    await handleResponse<unknown>(response);
  },
};
